import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
import Page from '../../../atoms/layout/page';
import Sidebar from './sidebar';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import List from './list';
import { getBillingDetails } from "../../../../store/actions/admin/user";
import AnalyzeMobileSection from '../../../atoms/creator/analyzeMobileSection';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    position: 'relative'
  },
  menu: {
    position: 'absolute',
    right: 10,
    top: 10,
    borderRadius: 20,
    width: 40,
    height: 40,
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}));

function MailView() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const pageRef = useRef(null);
  const { billingDetails } = useSelector((state: any) => state.adminUser);
  const apolloClient = useSelector((state: any) => state.apolloClient);

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [BillingDetails, setBillingDetails] = useState<any>();
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'));

  useEffect(() => {
    const request = { username: loginUserData.username };
    dispatch(getBillingDetails(apolloClient.client, request));
  }, [apolloClient.client, dispatch, loginUserData.user_id]);

  useEffect(() => {
    if (billingDetails) {
      setBillingDetails(billingDetails);
    }
  }, [billingDetails]);

  return (
    <Page
      className={classes.root}
      title={"Admin"}
      ref={pageRef}
    >

      {!isMobileDevice ? <Grid container>
        <Grid item md={2}>
          <Sidebar containerRef={pageRef} sidebarOpen={sidebarOpen} closeSidebar={() => setSidebarOpen(false)} billingdetails={BillingDetails} />
        </Grid>
        <Grid item md={10} xs={12} className="p-20">
          <IconButton onClick={() => setSidebarOpen(true)} className={classes.menu} color="primary" aria-label="add to shopping cart">
            <ListIcon />
          </IconButton>
          <List />
        </Grid>
      </Grid> : <Grid container><Grid item md={12}><AnalyzeMobileSection page={true} /></Grid></Grid>}
    </Page>
  );
}

export default MailView;
